module.exports = __webpack_public_path__ + "media/images/pc/brands/tvb/store_horie-94282cecf5e511be8137adaf8bc26c03.jpg";